import update from 'immutability-helper'
import React from 'react'
import Text from 'react-text'
import LinesEllipsis from 'react-lines-ellipsis'
import {Link} from 'react-router-dom'
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {Consumer} from '../../../context'
import Label from '../../label'
import confirmDialog from '../../confirm-dialog'
import AddStandards from '../../add-standards'
import {isUUID} from '../../../helpers/utils'
import {groupPlanningStandards} from 'components/standards-selector/domain/planning-summary.cjs'

import './add-standard.styl'

function Standard (props) {
  const {code, description, deleteStandard} = props
  return (
    <div className="standard">
      <div className="content">
        {code != undefined && (<div className="code">{code}</div>)}
        {code == undefined && (<div className="code"><Text id="expectation" /></div>)}
        <div className="description" title={description}>
          <LinesEllipsis
            text={description}
            maxLine={3}
            ellipsis="..."
            trimRight
            basedOn='letters'
          />
        </div>
      </div>
      <div className="actions">
        <div className="delete" onClick={deleteStandard}>
          <FontAwesomeIcon icon={faTrashAlt} />
        </div>
      </div>
    </div>
  )
}

export default function AddStandard () {

  return (<Consumer>{ context => {
    const {newPlan, languageId, link} = context
    const {content = {}} = newPlan
    const {standards = []} = content

    const deleteStandard = (index, title) => {
      return () => {
        confirmDialog({
          className: 'delete-field',
          translate: context.translate,
          children: (
            <div className="message">
              <div className="question">
                {context.translate('confirm_delete_item')}
              </div>
              <div className="title">
                {title}
              </div>
            </div>
          ),
          onConfirm: () => {
            const standards = update(newPlan.content.standards, {$splice: [[index,1]]})
            context.setState({newPlan: {...newPlan, content: {...content, standards}}})
          }
        })
      }
    }

    const editionGroups = groupPlanningStandards(standards)
    const items = editionGroups.map(group => (
      <div className="edition-group" key={group.id}>
        <div className="edition-heading"><Text id="standards" /> · {group.year}</div>
        {group.items.map(({item: standard, index}) => (
          <Standard
            key={`${group.id}:${standard.id}:${index}`}
            index={index}
            className="standard"
            deleteStandard={deleteStandard(index, standard.code ? standard.code.toUpperCase() : standard.description)}
            context={context}
            {...standard}
          />
        ))}
      </div>
    ))

    return (
      <div className="standards">
        { context.section == 'add-standards' && (<AddStandards />)}
        <div className="head">
          <label><Text id="standards" /></label>
          <Link
            className="add-standard"
            to={context.link({section: 'add-standards'}, context.match.path, {preserveQuery: true, query: {subject: newPlan.subject, grade: newPlan.grade}})}
          >
            +
          </Link>
        </div>
        { items.length > 0 && (
          <div className="content">
            {items}
          </div>
        )}
      </div>
    )}}</Consumer>)
}
